/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountdangerheading2Inputs */

const en_accountdangerheading2 = /** @type {(inputs: Accountdangerheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete my account`)
};

const pt_accountdangerheading2 = /** @type {(inputs: Accountdangerheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar a minha conta`)
};

/**
* | output |
* | --- |
* | "Delete my account" |
*
* @param {Accountdangerheading2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const accountdangerheading2 = /** @type {((inputs?: Accountdangerheading2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdangerheading2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdangerheading2(inputs)
	return pt_accountdangerheading2(inputs)
});
export { accountdangerheading2 as "accountDangerHeading" }